export const scrollSmoothly = (id: string) => {
    const menuElement = document.getElementById(id)
    if (menuElement) {
        menuElement.scrollIntoView({ behavior: 'smooth' })
    }
}